export default __webpack_public_path__ + "static/frederik-490e679b3e8da1c68c224cee58ce1ab0.jpg";